



import React, { useState, useRef } from 'react';
import html2pdf from 'html2pdf.js';
import { useSelector } from 'react-redux';
import signature from "../../assets/Images/ejobs-logo.svg"
const EmploymentOfferEditor = () => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const [message, setMessage] = useState(` 


ESSENTIAL.NG
No 7, Kaffi Street, Alausa Ikeja, Lagos
08154556666
Letter of Temporary Employment
To Mr.Mrs.Miss
LETTER OF TEMPORARY EMPLOYMENT.
Sequel to your letter of application for employment and with reference to the interview for employment the management had with you on  the ….. day of……….202.., Management is pleased to inform you that you have been shortlisted amongst the successful candidates for the position of ……………… you were interviewed for with a starting salary of………....which may be reviewed upward immediately after your probationary period of 3 to 6 months.
Accordingly, a Seven (7) days temporary employment has been offered to you. You are required, during this 7 days temporary employment, to familiarized yourself of your responsibilities and duties in the company and to attend the training set out by management and to provide the company with the following items:
1.	A duly filled and executed guarantor’s form.
2.	One passport photograph. 
3.	A copy of your valid means of identification such as National ID card, Permanent voters card, NIN, Drivers license, International passport etc.
4.	And a duly completed and signed company’s employee personal information form.
5.	Any other documents management may required from you as it relates to the position you are offered in the company.
Immediately after the 7 days period and you have provided the said documents, you will be issued with your full letter of employment as a full time staff of the company.
The company’s dress code is formal dress of black trouser or skirt, white shirt and black shoe. 
We advise you to abide by the company’s ethics, employee handbook and Terms and Conditions of the company that applies.
Thank you and please accept the assurances of management’s best regards.
Your faithfully
FOR: ESSENTIAL LTD

_________________
(Human Resources)


`);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const contentRef = useRef(null);

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  const handleDownload = () => {
    if (!contentRef.current) {
      alert('Error: Content is not available for download.');
      return;
    }
    const element = contentRef.current;
    const opt = {
      margin: 1,
      filename: 'Employment_Offer.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };
    html2pdf().set(opt).from(element).save();
  };

  const handlePrint = () => {
    if (!contentRef.current) {
      alert('Error: Nothing to print. Please try again.');
      return;
    }
    window.print();
  };

  const handleSendToWhatsApp = () => {
    if (!whatsappNumber) {
      alert('Please enter a valid WhatsApp number.');
      return;
    }
    const cleanedNumber = whatsappNumber.replace(/\D/g, '');
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${cleanedNumber}?text=${encodedMessage}`;
    alert('Please download the PDF first and attach it in WhatsApp after clicking OK.');
    handleDownload();
    window.open(whatsappUrl, '_blank');
    setIsModalOpen(false);
  };

  const handleSendToEmail = () => {
    if (!emailAddress) {
      alert('Please enter a valid email address.');
      return;
    }
    const subject = encodeURIComponent('Temporary Employment Offer from ESSENTIAL.NG');
    const encodedMessage = encodeURIComponent(message);
    const mailtoUrl = `mailto:${emailAddress}?subject=${subject}&body=${encodedMessage}`;
    alert('Please download the PDF first and attach it in your email client after clicking OK.');
    handleDownload();
    window.open(mailtoUrl, '_blank');
    setIsEmailModalOpen(false);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-3xl mx-auto bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Edit Employment Offer</h2>
        <textarea
          value={message}
          onChange={handleMessageChange}
          className="w-full p-4 border border-gray-300 rounded mb-4 h-64 resize-y"
          placeholder="Edit the employment offer message here..."
        />
        <div className="flex flex-wrap gap-4 mb-6">
          <button
            onClick={handleDownload}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded"
          >
            Download PDF
          </button>
          <button
            onClick={handlePrint}
            className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded"
          >
            Print
          </button>
          <button
            onClick={() => setIsModalOpen(true)}
            className="bg-teal-600 hover:bg-teal-700 text-white font-semibold py-2 px-4 rounded"
          >
            Send to WhatsApp
          </button>
          <button
            onClick={() => setIsEmailModalOpen(true)}
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded"
          >
            Send to Email
          </button>
        </div>
        <div ref={contentRef} className="prose max-w-none">
          {/* Styled Heading */}
          <div className="text-center mb-6">
            <h1 className="text-3xl font-bold text-gray-900 uppercase tracking-wide">ESSENTIAL.NG</h1>
            <p className="text-sm font-medium text-gray-700">No 7, Kaffi Street, Alausa Ikeja, Lagos</p>
            <p className="text-sm font-medium text-gray-700">08154556666</p>
            <h2 className="text-xl font-semibold text-gray-800 mt-4 border-b-2 border-gray-900 pb-1 inline-block">
              Letter of Temporary Employment
            </h2>
          </div>
          <p className="whitespace-pre-wrap">{message}</p>
        </div>
      </div>

      {/* WhatsApp Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Enter WhatsApp Number</h3>
            <input
              type="tel"
              value={whatsappNumber}
              onChange={(e) => setWhatsappNumber(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded mb-4"
              placeholder="Enter WhatsApp number (e.g., +2341234567890)"
            />
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setIsModalOpen(false)}
                className="bg-gray-500 hover:bg-gray-600 text-white py-2 px-4 rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleSendToWhatsApp}
                className="bg-teal-600 hover:bg-teal-700 text-white py-2 px-4 rounded"
              >
                Send
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Email Modal */}
      {isEmailModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Enter Email Address</h3>
            <input
              type="email"
              value={emailAddress}
              onChange={(e) => setEmailAddress(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded mb-4"
              placeholder="Enter email address (e.g., example@domain.com)"
            />
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setIsEmailModalOpen(false)}
                className="bg-gray-500 hover:bg-gray-600 text-white py-2 px-4 rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleSendToEmail}
                className="bg-indigo-600 hover:bg-indigo-700 text-white py-2 px-4 rounded"
              >
                Send
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Print Styles */}
      <style jsx global>{`
        @media print {
          body * { visibility: hidden; }
          div[ref="contentRef"] * { visibility: visible; }
          div[ref="contentRef"] { position: absolute; left: 0; top: 0; width: 100%; }
          button, textarea, .fixed { display: none !important; }
        }
      `}</style>
    </div>
  );
};

export default EmploymentOfferEditor;